module.exports = "/_next/static/images/62d446fe3ec3279d138079091e256747-cajitas-right-mobile.jpg.webp";